'use client';

import { ComponentPropsWithRef } from 'react';

import { cn } from '../../utils/css/cn';

export type TextareaProps = ComponentPropsWithRef<'textarea'> & {
	errorMessage?: string;
};

export const Textarea = ({ ref, className, errorMessage, ...props }: TextareaProps) => {
	return (
		<>
			<textarea
				ref={ref}
				className={cn(
					'w-full border border-takeda-medium-grey-600 p-4 outline-0 resize-none placeholder:text-takeda-medium-grey-600 placeholder:font-light',
					{
						'border-red-600': errorMessage,
					},
					className,
				)}
				{...props}
			/>
			{errorMessage && <div className="text-red-600 text-label-sm">{errorMessage}</div>}
		</>
	);
};

Textarea.displayName = 'Textarea';
